import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { ProfileForm } from '@components/Numbers/Details/Form';
import { numberApi } from '@reducers/number/number';

export const ProfileTab = ({ did, profileID }) => {
  const { isLoading } = numberApi.useGetDetailsQuery({ did });

  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }

  if (!profileID) {
    return (
      <Row>
        <Col className="textRed">
          Your Did is missing profile, please contact <b>support@didxl.com</b>{' '}
          for more information.
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <ProfileForm did={did} profileID={profileID} />
    </Row>
  );
};
